import clsx from 'clsx';
import { ApplicationLoader } from 'components/ApplicationLoader/ApplicationLoader';
import {
  ReviewOfferContext,
  ReviewOfferProvider,
} from 'components/ReviewOffer/ReviewOffer.context';
import { useIntroducerContext } from 'contexts/IntroducerContext/IntroducerContext';
import { TIntroducerApplication } from 'lendingApi/applications.types';
import { shouldShowNoAvailableFunds } from 'utils/application/application.helpers';
import { SummaryCard } from '../SummaryCard';
import { getStatusComponents } from './SummaryWrapper.helpers';
import styles from './SummaryWrapper.module.css';

type TProps = {
  applicationStatus: TIntroducerApplication['status'];
};

export const SummaryWrapper = ({ applicationStatus }: TProps) => {
  const { checkIntroducerPermission } = useIntroducerContext();

  return (
    <ReviewOfferProvider>
      <ReviewOfferContext.Consumer>
        {(state) => {
          if (!state?.selectedApplication || state.isLoading) {
            return <ApplicationLoader />;
          }

          const isPartnerChannel = state.selectedApplication.is_partner_channel;

          const { bottomContent, sideContent } = getStatusComponents({
            applicationStatus,
            isPartnerChannel,
            checkIntroducerPermission,
            shouldShowNoAvailableFunds: shouldShowNoAvailableFunds(
              state.selectedApplication,
            ),
          });

          return (
            <div
              className={clsx(styles.summaryWrapper, styles[applicationStatus])}
            >
              <div className={styles.summaryCardContainer}>
                <SummaryCard />
                {sideContent}
              </div>
              <div
                data-testid="bottom-content"
                className={styles.bottomSection}
              >
                {bottomContent}
              </div>
            </div>
          );
        }}
      </ReviewOfferContext.Consumer>
    </ReviewOfferProvider>
  );
};
